import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link, useHistory} from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  Alert,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Loader from "../../components/Common/Loader"

import { campaignCreate } from "../../store/campaign/actions";
import { getSupervisor } from "../../helpers/backend";
import ButtonVolver from "../../components/ButtonVolver";

const CampaignCreate = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [contactsList, setContactsList] = useState({});
  const getContactsData = async () => {
    const response = await getSupervisor();
    const data = response.data;
    setContactsList(data);
  };

  useEffect(() => {
    getContactsData();

  }, []);

  const [formData, setFormData] = useState({
    
    name: "",
    description:"",
    encargado: [],
  });
  
  const {
    name,    
    description,    
  } = formData;
  
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    }

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(campaignCreate(formData));
  };
  
  const redirect = () => {
    history.push("/campaign");
  };
const theme = useSelector((state) => state.theme.theme) || "light";
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Cuidad Limpia  | Campañas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Campañas
            </span>
          </Col>
          {props.loading ? (
            <Loader />
          ) : (
          <div className="d-flex justify-content-center">
              {props.campaignCreated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={false}
                  timeout={2000}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Se ha
                  agregado <b>{props.campaignCreated.nombre}</b> correctamente.
                </SweetAlert>
              ) : null}

              <Card
                style={{
                  width: "60rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="font-size-20"> Agregar Campañas</h2>
                </CardTitle>
                <CardBody>
                <Form onSubmit={onSubmit} className="form-control">
                  <Row className="justify-content-md-center" >
                    <Col lg={10}>
                <Row className="mt-3">
                  <Col>
                    <Label
                      for="name"                      
                    >
                      Nombre
                    </Label>
                    <Input                      
                      id="name"
                      name="name"
                      type="name"
                      onChange={onChange}
                      value= {name}
                      autoFocus
                      required
      
                    />
                    {props.error && props.error.name ? (
                      <Alert color = 'danger' className="mt-2">{props.error.name}</Alert>
                    ):null}
                  </Col>      
                </Row>
                <Row className="mt-3">
                  <Col>  
                    <Label
                      for="description"
                      
                    >
                      Descripción
                    </Label>
                    <Input
                     
                      id="description"
                      name="description"
                      type="text"
                      onChange={onChange}
                      value={description}

                      required 
                    />
                   
                    <FormFeedback>{props.error.description}</FormFeedback>
                    

                  </Col>
                  <Col>
                    <Label
                      for="encargado"                      
                    >  Encargado
                    </Label>  
                   <Select   
                      isMulti={true}                  
                      id="encargado"
                      name="encargado"  
                      options={ Array.isArray(contactsList) ? 
                        contactsList.map(item=> ({label: item.get_full_name, value: item.id})) : [] } 
                      placeholder='Seleccione'                  
                      onChange={(item) => setFormData({
                        ...formData,
                        encargado : item && item.map( item => item.value)
                      })}                                          
                      required 
                      menuPosition="fixed"
                      styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor:
                              theme === "dark" ? "#242424" : "#fff",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            borderColor:
                              theme === "dark" ? "#3b3b3b" : "#d2d2d2",
                            cursor: "pointer",
                            fontSize: "0.9rem",
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor:
                              theme === "dark" ? "#242424" : "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                          }),
                          option: (base, { isFocused, isSelected }) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? theme === "dark"
                                ? "#242424"
                                : "#ccc"
                              : isFocused
                              ? theme === "dark"
                                ? "#121212"
                                : "#ddd"
                              : "transparent",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            padding: "10px",
                            fontSize: "0.9rem",
                            cursor: "pointer",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                          }),
                        }}
                    /> 
                    

                    {props.error && props.error.encargado ? (
                    <Alert color = 'danger' className="mt-2">{props.error.encargado}</Alert>
                    ):null}

                  </Col>
                </Row>

                    <Row>
                      <Col className="d-flex justify-content-center mt-5 mb-2 " >
                        <Link className="btn btn-secondary text-dark me-1" to="/campaign">
                          Volver
                        </Link>
                        <Button color="primary"  type="submit">
                          Agregar
                        </Button>
                      </Col>
                    </Row>
                    </Col>
                  </Row>
                </Form>
                </CardBody>
              </Card>

            
          </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { error, loading, campaignCreated } = state.Campaign;
  return { error, loading, campaignCreated };
};

export default withRouter(connect(mapStateToProps)(CampaignCreate));